import type { PaginatedResponse } from 'modules/avs/avs.types';
import { VerificationStatus } from 'modules/avs/avs.types';

export { VerificationStatus };

export interface CorporateVerificationState {
  isFetchingVerificationRecords: boolean;
  isUploadingBulkVerification: boolean;
  isFetchingBulkVerificationResult: boolean;
  isFetchingVerificationResultData: boolean;
  verificationRecords: PaginatedResponse<CorporateVerificationRecord> | null;
  bulkVerificationResponse: CorporateVerificationResponse<never> | null;
  bulkVerificationResult: CorporateVerificationBulkDetails | null;
  bulkVerificationResultData: PaginatedResponse<CorporateVerificationDetails> | null;
}

export interface CorporateVerificationRecord {
  id: string;
  name: string;
  verifications_processed: number;
  status: VerificationStatus;
  created_at: string;
}

export interface CorporateVerificationResponse<T> {
  status: VerificationStatus;
  results_id: string;
  message: string;
  timestamp: string;
  status_detail: {
    granular_status_code: string;
    status_additional_info: string;
  };
  verifications?: T;
}

export type CorporateVerificationBulkDetails = {
  result: {
    verified: number;
    not_verified: number;
  };
  completed_at?: string;
  created_at: string;
  created_by: string;
};

export enum CorporateStatus {
  verified = 'VERIFIED',
  notVerified = 'NOT_VERIFIED',
}

export enum CorporateRequestStatus {
  ok = 'OK',
  failed = 'FAILED',
}

export enum CorporateInfoType {
  basic = 'BASIC',
  full = 'FULL',
}

export interface CorporateVerificationDetails {
  id: string;
  application_id: string;
  unified_national_number: string;
  info_type: CorporateInfoType;
  status: CorporateStatus;
  request_status: CorporateRequestStatus;
  created_at: string;
}

export const failedCorporateVerificationStatuses = [
  VerificationStatus.invalidParameters,
  VerificationStatus.failed,
  VerificationStatus.internalServerError,
];

